export enum UserRolesEnum {
  ADMIN = 'ROLE_SUPER_ADMIN',
  USER = 'ROLE_USER',
  TECHNICIAN = 'ROLE_TECHNICIAN',
  ROLE_REGIONAL_MANAGER = 'ROLE_REGIONAL_MANAGER',
  ROLE_AGENCY_DIRECTOR = 'ROLE_AGENCY_DIRECTOR',
  ROLE_AVF_REFERENT = 'ROLE_AVF_REFERENT',
  ROLE_RT_MANAGER = 'ROLE_RT_MANAGER',
  ROLE_DOCTOR = 'ROLE_DOCTOR',
  ROLE_PHARMACIST = 'ROLE_PHARMACIST',
  ROLE_PATIENT = 'ROLE_PATIENT',
}
